import styled from 'styled-components'

const HorseStyled = styled.div``

export default HorseStyled
